/**
 * 매출/정산 — 매출·정산 통합 페이지 (탭)
 *  - [매출] 탭: 본사 실매출 (RevenuePage)
 *  - [정산] 탭: 사업장×월 정산 정보 (SettlementInfoPage)
 *  - 탭 상태는 ?tab=revenue|settlement 로 URL 유지 → 뒤로가기/딥링크/북마크 보존
 */
import { useSearchParams } from 'react-router-dom';
import { RevenuePage } from '../revenue';
import { SettlementInfoPage } from './SettlementInfoPage';

type TabKey = 'revenue' | 'settlement';

export function RevenueSettlementPage() {
  const [params, setParams] = useSearchParams();
  const tab: TabKey = params.get('tab') === 'settlement' ? 'settlement' : 'revenue';

  const setTab = (next: TabKey) => {
    const p = new URLSearchParams(params);
    p.set('tab', next);
    setParams(p, { replace: true });
  };

  const tabClass = (active: boolean) =>
    `-mb-px border-b-2 px-5 py-2.5 text-[15px] transition-colors ${
      active
        ? 'border-blue-600 font-medium text-blue-600'
        : 'border-transparent font-normal text-gray-500 hover:text-gray-800'
    }`;

  return (
    <div className="p-6">
      {/* 페이지 타이틀 */}
      <div className="mb-4 flex items-center gap-2">
        <h1 className="text-2xl font-bold text-gray-900">매출/정산</h1>
      </div>

      {/* 탭 */}
      <div className="mb-4 flex gap-1 border-b border-gray-200" role="tablist">
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'revenue'}
          className={tabClass(tab === 'revenue')}
          onClick={() => setTab('revenue')}
        >
          매출
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={tab === 'settlement'}
          className={tabClass(tab === 'settlement')}
          onClick={() => setTab('settlement')}
        >
          정산
        </button>
      </div>

      {/* 탭 내용 */}
      {tab === 'revenue' ? (
        <RevenuePage embedded />
      ) : (
        <SettlementInfoPage embedded />
      )}
    </div>
  );
}
